import api from "@/apis/TransactionControlReportAPI";
import Crud from "./crud-base";
var crud = new Crud("transactioncontrolreport", api);

const state = {
  ...crud.state,
  //...stateOverride,
  _config: {
    field: {},
  },
  overview: {
    totalJetpaypayToMerchant: 0, // tổng tiền thanh toán
    totalJetPayPaid: 0, // tổng tiền đã thanh toán
  },
};
const getters = {
  ...crud.getters,
  //...gettersOverride
};
const actions = {
  ...crud.actions,
  //...actionsOverride,
  /**
   *  Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }
    context.commit("setItems", { result: res, payload: payload });
    context.commit("setOverviewData", res.customerData);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  setOverviewData(state, data) {
    state.overview = { ...state.overview, ...data };
    state.summary = { ...state.summary, ...data };
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
